/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
import { AddressTypeSchema } from '../enums/AddressType.schema';
import { LatitudeLongitudeSchema } from './LatitudeLongitude.schema';
const baseSchema = z.object({
    type: AddressTypeSchema,
    streetLine1: z.string().min(5, { message: "Please provide between 5 and 50 characters." }).max(50, { message: "Please provide between 5 and 50 characters." }),
    streetLine2: z.string().max(50, { message: "Please provide up to 50 characters." }).nullish(),
    city: z.string().min(1, { message: "Please provide a city name between 1 and 100 characters." }).max(100, { message: "Please provide a city name between 1 and 100 characters." }).nullish(),
    state: z.string().min(1, { message: "Please provide a state/province/region between 1 and 100 characters." }).max(100, { message: "Please provide a state/province/region between 1 and 100 characters." }).nullish(),
    zipCode: z.string().min(5, { message: "Please enter a valid ZIP code format (12345 or 12345-6789) for better address verification" }).max(20, { message: "Please enter a valid ZIP code format (12345 or 12345-6789) for better address verification" }).regex(new RegExp("^\\d{5}(-\\d{4})?$"), { message: "Please enter a valid ZIP code format (12345 or 12345-6789) for better address verification" }).nullish(),
    country: z.string().default("US").nullish(),
    location: z.lazy(() => LatitudeLongitudeSchema).nullish(),
    verifiedAt: z.coerce.date().nullish(),
    verifiedBy: z.string().nullish(),
}
).strict();
export const AddressSchema = baseSchema;
